import React, { useState } from 'react';
import WelcomeContainer from './containers/WelcomeContainer/WelcomeContainer';
import EditorContainer from './containers/EditorContainer/EditorContainer';
import './styles/App.css';
import { useGlobalContext } from 'contexts/GlobalContext';


const App: React.FC = () => {
  
   const {projectRootPath} = useGlobalContext();
   return projectRootPath ? <EditorContainer /> : <WelcomeContainer />;

}

export default App; 